// export const apilink = 'http://localhost:5000';

// export const apilink = 'https://csv-read.herokuapp.com';
export const apilink = 'https://csv-read.onrender.com';
